import {useRef, useState} from 'react';
import styles from "./UpdateProfile.module.css"

import {Link, useNavigate} from "react-router-dom"

import { useAuth } from '../../contexts/authContext';

export default function UpdateProfile() {
  const emailRef = useRef()
  const passwordRef = useRef()
  const passwordConfirmRef = useRef()

  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false);

  const {currentUser, updateEmail, updatePassword} = useAuth()

  const navigate = useNavigate();

  function handleSubmit(e) {
    e.preventDefault();

    if(passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match");
    }

    const promises = []

    setError("")
    setLoading(true)

    if (emailRef.current.ref != currentUser.email) {
      promises.push(updateEmail(emailRef.current.value))
    }

    if (passwordRef.current.value) {
      promises.push(updatePassword(passwordRef.current.value))
    }

    // if (currentUser.auth.currentUser.providerData[0].providerId !== "password") {
    //   setError("Unable to update your account. This is because your account was created using an external provider")

    //   return new Error("User account provider id not email/password")
    // }

    Promise.all(promises)
      .then(() => {
        navigate("/profile")
      })
      .catch((e) => {
        console.log(e)
        setError("An error occured while updating your account")
      })
      .finally(() => {
        setLoading(false);
      })
  }

  return (
    <div className={styles.updateProfileContainer}>
      <h2>Update Profile</h2>

      {error && <p>{error}</p>}

      <form className={styles.updateProfileForm} onSubmit={handleSubmit}>
        <label htmlFor="email">Email</label>
        <input type="email" id="email" placeholder="name@example.com" ref={emailRef} defaultValue={currentUser.email} />

        <label htmlFor="password">Password</label>
        <input type="password" id="password" placeholder="Leave blank to keep the same" ref={passwordRef} />

        <label htmlFor="password-confirm">Confirm your password</label>
        <input type="password" id="password-confirm" placeholder="Leave blank to keep the same" ref={passwordConfirmRef} />

        <button type="submit" disabled={loading}>Save</button>
      </form>

      <Link to="/profile">Cancel</Link>
    </div>
  );
}
